function getPageMatrix(global){
    if(!global) global = window;

    let pageMatrix = {};

    Object.defineProperties(pageMatrix, {
        x: {
            get (){
                return 'pageXOffset' in global ?
                    global.pageXOffset :
                    document.documentElement['scrollLeft'] || document.body['scrollLeft'];
            }
        },
        y: {
            get (){
                return 'pageYOffset' in global ?
                    global.pageYOffset :
                    document.documentElement['scrollTop'] || document.body['scrollTop'];
            }
        }
    });

    return pageMatrix;
}

module.exports = getPageMatrix;